import keyCodes from '../../../../../../editJournal/constants/keyCodes';
import isAtBeginning from './isAtBeginning';
import renderDict from './renderDict';
import handleBulletShifting from '../../../../../../editJournal/slateUtilities/plugins/handleBulletShifting';
import mergeBullets from '../../../../../../editJournal/slateUtilities/plugins/mergeBullets';
import isStartOfBlock from '../../../../../../editJournal/slateUtilities/plugins/Xscript/isStartOfBlock';
import isStartOfNode from '../../../../../../editJournal/slateUtilities/plugins/Xscript/isStartOfNode';
import findBulletLevel from '../../../../../../editJournal/slateUtilities/plugins/findBulletLevel';
import convertToBullet from '../../../../../../editJournal/slateUtilities/plugins/convertToBullet';
import removeSelectedNodes from './removeSelectedNodes';

export default (params) => {
  const { event, editor, updatePopUpKeys, showCommentCard, showContextCard } =
    params;
  if (event.which === keyCodes.BACKSPACE) {
    const {
      value: { focusBlock, previousBlock, document, selection },
    } = editor;
    const { key: focusBlockKey, type: focusBlockType } = focusBlock;
    const parent = document.getParent(focusBlockKey);
    const { type: parentType, nodes: parentNodes } = parent;
    const levelOfBullet = findBulletLevel(editor);

    /**
     * Replace this method once
     * multiple selection of nodes is restricted to inputs with selection drag
     */

    /**
     * Backspacing comments
     */
    const isPreventDefault = removeSelectedNodes({
      editor,
      props: { updatePopUpKeys, showCommentCard, showContextCard },
      eventCode: keyCodes.BACKSPACE,
    });
    if (isPreventDefault) return true;

    if (renderDict[focusBlockType] === 'array_item') {
      if (selection.isExpanded) {
        editor.insertText('');
        return true;
      }
    }

    if (isStartOfNode(editor) || isStartOfBlock(editor)) {
      editor.select(selection);
      if (renderDict[parentType] === 'organization_role_editable_div') {
        const parentNodesArray = parentNodes.toArray();
        const firstNode = parentNodesArray[0];
        if (firstNode.key !== focusBlockKey) {
          if (document.getParent(previousBlock.key).type === 'list_item') {
            convertToBullet(editor);
          }
          editor.deleteBackward();
          return true;
        }
      } else if (renderDict[parentType] === 'list_item') {
        if (levelOfBullet === 0) {
          handleBulletShifting(
            editor,
            true,
            editor.value.focusBlock,
            null,
            null,
            null,
            editor.value.document,
          );
          editor.select(selection);
        } else mergeBullets(editor, event);
        return true;
      }
    }
    editor.select(selection);

    if (!selection.isExpanded) {
      const isBeginning = isAtBeginning(editor, event);
      if (isBeginning) return true;
    }
  }

  return false;
};
